import * as yup from 'yup';

export const TwoFactorCodeValidationSchema = yup.object({
	code: yup
		.string()
		.trim()
		.required('auth.two_factor.validation.enter_code')
		.matches(/^\d{6}$/, { message: 'auth.two_factor.validation.code_format' }),
});

export const TwoFactorRecoveryValidationSchema = yup.object({
	recoveryCode: yup
		.string()
		.trim()
		.required('auth.two_factor.validation.enter_recovery_code')
		.matches(/^[a-zA-Z0-9]{4}-?[a-zA-Z0-9]{4}$/, {
			message: 'auth.two_factor.validation.recovery_code_format',
		}),
});

export type TwoFactorCode = yup.InferType<typeof TwoFactorCodeValidationSchema>;
export type TwoFactorRecovery = yup.InferType<typeof TwoFactorRecoveryValidationSchema>;
